export const WINDOW_VARIANTS = [
  { id: "oeffnend", name: "Fenster zum Öffnen", priceCents: 176358, required: 12, detail: "Inklusive Einbau" },
  { id: "festverglast", name: "Festverglastes Fenster", priceCents: 152658, required: 4, detail: "Festverglasung" },
] as const;
export type WindowVariantId = typeof WINDOW_VARIANTS[number]["id"];
export type WindowShare = "ganz" | "halb";
export const WINDOW_ADVERTISING_YEARS = 5;
export const WINDOW_ADVERTISING_LAYOUT = "Milchglas und geplottetes Logo ohne Farbe";
export function windowSponsorshipPrice(id: WindowVariantId, share: WindowShare = "ganz") {
  const variant = WINDOW_VARIANTS.find(item => item.id === id);
  if (!variant) throw new Error("Ungültige Fenstervariante");
  return variant.priceCents / (share === "halb" ? 2 : 1);
}
export const formatWindowPrice = (cents: number) => (cents / 100).toLocaleString("de-DE", { style: "currency", currency: "EUR" });
export const WINDOW_TOTAL_CENTS = WINDOW_VARIANTS.reduce((sum, variant) => sum + variant.priceCents * variant.required, 0);
export function windowSponsorshipInterest(id: WindowVariantId, share: WindowShare = "ganz") {
  const variant = WINDOW_VARIANTS.find(item => item.id === id);
  if (!variant) throw new Error("Ungültige Fenstervariante");
  return `Fensterpatenschaft – ${variant.name} – ${share === "halb" ? "Halbes Fenster" : "Ganzes Fenster"} – ${formatWindowPrice(windowSponsorshipPrice(id, share))} brutto${id === "oeffnend" ? " inkl. Einbau" : ""} – Werbenutzung: ${WINDOW_ADVERTISING_LAYOUT} – zugesicherte Nutzungsdauer ${WINDOW_ADVERTISING_YEARS} Jahre`;
}